import { Box, Typography } from "@mui/material";

import type { FC } from "react";

export const SwagModalContent: FC = () => {
  return (
    <Box>
      <Box sx={(theme) => ({ height: 250, bgcolor: theme.palette.background.paper })}>
        <iframe
          src="https://media.changeengine.com/v/2c5cbefe-7931-4061-ab9b-bc9c2944ca3d"
          title="video"
          width="100%"
          height="100%"
          allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
          allowFullScreen
          style={{ border: "none" }}
        />
      </Box>
      <Typography sx={{ mt: 2 }} variant="body2">
        You’re Already Creating Magic—Let’s Make It Unforgettable.
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        With curated swag you can turn milestones, new hires, promotions, and cultural moments into
        lasting memories!
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        From design to delivery, we handle it all—so your team can focus on what matters most.
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        Swag brings pride, connection, and culture to life—amplifying every experience for your
        team!
      </Typography>
      <Typography fontWeight={700} sx={{ mt: 2 }} variant="body2">
        Ready to create something unforgettable?
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        Let’s do it.
      </Typography>
    </Box>
  );
};
